export enum MasterAPIErrorCodeEnum {
    EntityNotFound = 40004,
}
